import { render, staticRenderFns } from "./selectDependentVariable.vue?vue&type=template&id=28894d71&scoped=true"
import script from "./selectDependentVariable.vue?vue&type=script&lang=js"
export * from "./selectDependentVariable.vue?vue&type=script&lang=js"
import style0 from "./selectDependentVariable.vue?vue&type=style&index=0&id=28894d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28894d71",
  null
  
)

export default component.exports